import React from 'react';
import { Field } from 'redux-form';
import {
  listOfBank,
  numberOnly,
  alphaNumeric,
  inputField,
  renderSelectField,
} from '../utilsForm';
import styles from './koinworksForm.css';

const KoinworksBankForm = props => {
  const { bankName } = props;

  return (
    <div className={`col-md-12 col-lg-12`}>
      <div className="col-md-3">
        <label>Bank Information</label>
      </div>
      <div className="col-md-9">
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Bank Name
            <red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              name="bank_name"
              className={`form-control ${styles['bank-select']}`}
              id="bank_name"
              component={renderSelectField}
            >
              <option value="" key="">
                Select Your Bank Name
              </option>
              {listOfBank.map(option => (
                <option value={option.name} key={option.name}>
                  {option.name}
                </option>
              ))}
            </Field>
            {bankName === 'Other' && (
              <Field
                component={inputField}
                name="other_bank_name"
                placeholder="Your Bank Name"
                maxLength="255"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
                normalize={alphaNumeric()}
              />
            )}
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Account Number
            <red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="account_no"
              maxLength="16"
              minLength="10"
              placeholder="Account Number"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={numberOnly()}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Bank Account Owner's Name<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="bank_account_name"
              maxLength="255"
              placeholder="The owner`s name of this bank account"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={alphaNumeric()}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Bank Branch Name
            <red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="bank_branch_name"
              maxLength="255"
              placeholder="Bank Branch Name"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={alphaNumeric()}
            />
          </div>
        </div>
      </div>
      <div className="col-md-12 col-lg-12">
        <hr />
      </div>
    </div>
  );
};

export default KoinworksBankForm;
